var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPillup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 15,
    viewBox: "0 0 36 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1379_15972)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.938158 1.69867H4.89061C7.19819 1.69867 8.59126 3.09905 8.59126 5.15762V5.18601C8.59126 7.51624 6.84998 8.70249 4.68042 8.70249H3.06342V9.50278C3.07297 10.0768 2.85412 10.6312 2.45512 11.044C2.05612 11.4567 1.50949 11.6942 0.935486 11.7041L0.938158 1.69867ZM4.75182 6.74433C4.96456 6.76782 5.1799 6.74605 5.3836 6.68051C5.58737 6.61502 5.77497 6.50722 5.93419 6.36417C6.0934 6.22112 6.22061 6.04605 6.30748 5.85043C6.39434 5.65482 6.43895 5.44303 6.43831 5.22896V5.20058C6.43831 4.2139 5.77745 3.68521 4.71084 3.68521H3.06603V6.74433H4.75182Z",
    fill: "#062140"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.43317 1.26978H11.6443V3.19948H9.43317V1.26978ZM9.48866 4.0454H11.5888V11.7068H9.48866V4.0454Z",
    fill: "#062140"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8325 1.26978H14.9333V11.7041H12.8325V1.26978Z",
    fill: "#062140"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2305 1.26978H18.3306V11.7041H16.2305V1.26978Z",
    fill: "#062140"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4117 9.00251V4.04276H21.5126V8.31651C21.5126 9.34551 21.9685 9.87414 22.784 9.87414C23.5995 9.87414 24.0965 9.34551 24.0965 8.31651V4.04276H26.1972V11.7041H24.0965V10.6176C23.8652 10.9865 23.5458 11.292 23.1671 11.5065C22.7883 11.7211 22.3621 11.8381 21.9269 11.8468C20.3264 11.8468 19.4117 10.7749 19.4117 9.00251Z",
    fill: "#1C8067"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2837 4.0428H29.3838V5.14314C29.6276 4.75343 29.9686 4.43385 30.3734 4.2159C30.7781 3.99794 31.2326 3.88912 31.6921 3.9C33.4195 3.9 35.0624 5.30039 35.0624 7.85927V7.88765C35.0624 10.4465 33.4453 11.8468 31.6921 11.8468C31.2441 11.8538 30.8009 11.7538 30.3995 11.5549C29.998 11.356 29.6498 11.0642 29.3838 10.7036V11.8185C29.3934 12.3851 29.1775 12.9323 28.7837 13.3398C28.3898 13.7473 27.8503 13.9817 27.2837 13.9913V4.0428ZM32.9629 7.88765V7.85927C32.9884 7.60046 32.9613 7.33923 32.8832 7.09124C32.8051 6.84325 32.6777 6.61359 32.5086 6.41606C32.3395 6.21853 32.1323 6.05721 31.8994 5.94178C31.6663 5.8264 31.4125 5.75927 31.1528 5.7445C30.1715 5.7445 29.3567 6.58775 29.3567 7.85927V7.88765C29.3567 9.1598 30.1715 10.0024 31.1528 10.0024C31.4129 9.98886 31.6674 9.92249 31.901 9.8075C32.1345 9.6925 32.3423 9.53119 32.5115 9.33334C32.6809 9.13556 32.8082 8.90539 32.8857 8.65689C32.9634 8.40832 32.9896 8.14665 32.9629 7.88765Z",
    fill: "#1C8067"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1379_15972"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35.0636,
    height: 14,
    fill: "white",
    transform: "translate(0 0.34375)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPillup);
export default __webpack_public_path__ + "static/media/pillup.2a5a2c488b17ca33eb9604223d0aea7e.svg";
export { ForwardRef as ReactComponent };